// extracted by mini-css-extract-plugin
export default {"errorContent":"errorContent---ltzvh"};